import React from "react";
import Heading from "../common/heading/Heading";
import "./about.css";

const AboutCard = () => {
  return (
    <section className="aboutHome">
      <div className="container flexSB">
        
        {/* قسم الفيديو مع حركة انزلاق */}
        <div className="left row slide-in-right">
          <div className="video-container">
            <iframe
              width="100%"
              height="350"
              src="https://www.youtube.com/embed/Tt1xBx1M6Nw?si=1HoKArpvH2CxAR6N"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>

        {/* قسم النصوص مع حركة انزلاق وتدرج في الظهور */}
        <div className="right row slide-in-left">
          <Heading
            subtitle="منصتك التعليمية المتكاملة لرحلة دراسية ممتعة ونتائج مبهرة."
            title="اكتشف عالمًا من المعرفة مع منصتنا"
          />

          <div className="items">
            <div className="item fade-in-up" style={{ animationDelay: "0.2s" }}>
              <div className="icon">🚀</div>
              <div className="text">
                <h2>محتوى تعليمي شامل ومبسط</h2>
                <p>شرح وافٍ وتفاعلي لجميع المواد الدراسية بأحدث الطرق التعليمية التي تضمن لك الفهم العميق والابتعاد عن الحفظ والتلقين.</p>
              </div>
            </div>

            <div className="item fade-in-up" style={{ animationDelay: "0.4s" }}>
              <div className="icon">💡</div>
              <div className="text">
                <h2>تدريبات واختبارات ذكية</h2>
                <p>بنك أسئلة ضخم، تطبيقات عملية، واختبارات دورية تحاكي امتحانات آخر العام لتقييم مستواك باستمرار وتحديد نقاط ضعفك لمعالجتها.</p>
              </div>
            </div>

            <div className="item fade-in-up" style={{ animationDelay: "0.6s" }}>
              <div className="icon">👨‍🏫</div>
              <div className="text">
                <h2>متابعة مستمرة ودعم أكاديمي</h2>
                <p>نخبة من أفضل المعلمين للإجابة على استفساراتك على مدار الساعة، مع توفير تقارير أداء دورية لمتابعة تقدمك خطوة بخطوة.</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default AboutCard;